import PageHead from './PageHead';
import { useLocation } from 'react-router-dom';
import { useTranslation } from '../contexts/LanguageContext';
import { alternateLinks } from '../i18n/languages';

const ROBOTS = 'index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1';

// Tells search engines which address holds each language version of the current page.
// Also sets the default title and replaces index.html's data-rh description/og:title/robots; pages override them.
function LanguageAlternates() {
    const { pathname } = useLocation();
    const { t, language } = useTranslation();
    const { canonical, alternates } = alternateLinks(pathname, language);
    return (
        <PageHead>
            <title>{t('home.seo.title')}</title>
            <meta name="description" content={t('home.seo.description')} />
            <meta property="og:title" content={t('home.seo.title')} />
            <meta name="robots" content={ROBOTS} />
            <link rel="canonical" href={canonical} />
            <meta property="og:url" content={canonical} />
            {alternates.map(a => <link key={a.hreflang} rel="alternate" hrefLang={a.hreflang} href={a.href} />)}
        </PageHead>
    );
}

export default LanguageAlternates;
